<script lang="ts">
  import TopicTitle from './TopicTitle.svelte';
  import UBar from './UBar.svelte';
  import { autorun } from 'mobx';
  import { onDestroy } from 'svelte';
  import type { UserTopicStore } from 'shared/src/user/userKnowledge/user.topic.store';
  import { getUBarColor } from './getUBarColor';
  import type { UserSkillStore } from 'shared/src/user/userKnowledge/user.skill.store';
  import SkillTitle from './SkillTitle.svelte';

  export let topic: UserTopicStore | undefined = undefined;
  export let skill: UserSkillStore | undefined = undefined;
  export let index: number = 0;

  $: color = getUBarColor(index);
  $: stroke = color[700];

  let percentage: number;
  const destroy = autorun(() => {
    percentage = topic?.score || skill?.score || 0;
  });
  onDestroy(destroy);
</script>

<UBar {percentage} {index}>
  {#if topic}
    <TopicTitle color="#fff" {stroke} {topic} />
  {:else if skill}
    <SkillTitle color="#fff" {stroke} {skill} />
  {/if}
</UBar>
